import ConversationAssistant from '@atlassian/conversation-assistant/AsyncConversationAssistant';

import { ConfluenceConversationAssistant } from './main.ts';

// Warms the Rovo chat sidebar's two lazy chunks (the Confluence
// `loadable-ConversationAssistant` wrapper and the platform
// `@atlassian/conversation-assistant` bundle) so the
// sidebar mounts without a cold bundle load on its critical path.
export function preloadConfluenceConversationAssistant(): void {
	ConfluenceConversationAssistant.preload();
	ConversationAssistant.preload();
}
